// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetSafetyHookLookupRequestModel from '../../model/get-safety-hook-lookup-request-model';
import GetSafetyHookLookupRequestDTO from '../dto/get-safety-hook-lookup-request-dto';
import dtoSchema from '../schemas/get-safety-hook-lookup-request-schema';

export default abstract class GetSafetyHookLookupRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetSafetyHookLookupRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.canFastenOnCounterbatten = data.canFastenOnCounterbatten;
      this.groupName = data.groupName;
      this.safetyHookType = data.safetyHookType;
      this.standardScrewThickness = data.standardScrewThickness;
      this.standardScrewLength = data.standardScrewLength;
      this.counterbattenScrewLength = data.counterbattenScrewLength;
      this.minimumScrewDepth = data.minimumScrewDepth;
      this.siHaDocumentationId = data.siHaDocumentationId;
      this.screwType = data.screwType;
      this.screwConnectionMustBeDocumented = data.screwConnectionMustBeDocumented;
      this.id = data.id;
      this.key = data.key;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  */
  canFastenOnCounterbatten?: boolean;
  /**
  */
  groupName?: string;
  /**
  */
  safetyHookType?: string;
  /**
  * @type {int32}
  */
  standardScrewThickness?: number;
  /**
  * @type {int32}
  */
  standardScrewLength?: number;
  /**
  * @type {int32}
  */
  counterbattenScrewLength?: number;
  /**
  * @type {int32}
  */
  minimumScrewDepth?: number;
  /**
  * @type {int64}
  */
  siHaDocumentationId?: number;
  /**
  */
  screwType?: string;
  /**
  */
  screwConnectionMustBeDocumented?: boolean;
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  key?: string;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetSafetyHookLookupRequestDTO>): GetSafetyHookLookupRequestModel;
  static toModel(dto: DeepPartial<GetSafetyHookLookupRequestDTO> | undefined | null): GetSafetyHookLookupRequestModel | undefined;
  static toModel(dto: DeepPartial<GetSafetyHookLookupRequestDTO> | undefined | null): GetSafetyHookLookupRequestModel | undefined {
    return dto ? new GetSafetyHookLookupRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetSafetyHookLookupRequestModel> | GetSafetyHookLookupRequestModel): GetSafetyHookLookupRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      canFastenOnCounterbatten: unwrapped.canFastenOnCounterbatten,
      groupName: unwrapped.groupName,
      safetyHookType: unwrapped.safetyHookType,
      standardScrewThickness: unwrapped.standardScrewThickness,
      standardScrewLength: unwrapped.standardScrewLength,
      counterbattenScrewLength: unwrapped.counterbattenScrewLength,
      minimumScrewDepth: unwrapped.minimumScrewDepth,
      siHaDocumentationId: unwrapped.siHaDocumentationId,
      screwType: unwrapped.screwType,
      screwConnectionMustBeDocumented: unwrapped.screwConnectionMustBeDocumented,
      id: unwrapped.id,
      key: unwrapped.key,
      searchCriteria: unwrapped.searchCriteria,
    } as GetSafetyHookLookupRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetSafetyHookLookupRequestModel, can not map to GetSafetyHookLookupRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
